<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TheProfile',
}
</script>

<style scoped></style>
